import { Div, Collection, CollectionPrinter, TextInput, NumberInput, RefJsonViewer, Table, Button } from "@tblabs/truffle";
import { ProductSelector } from "../../../../Components/ProductSelector";
import { BasketItem } from "../../../../Models/Basket/BasketItem";
import { BasketItemType } from "../../../../Models/Basket/BasketItemType";
import { RentBasketItem } from "../../../../Models/Basket/RentBasketItem";
import { SaleBasketItem } from "../../../../Models/Basket/SaleBasketItem";
import { ShopContent } from "../../../../Shop/ShopContent";
import { InfoBox } from "../../../Customer/InfoBox";
import { DateTimeEditInput } from "../../../../Components/Utils/DateSlider";
import { Box } from "../../../../Components/Utils/Box";


export class BasketEdit extends Div
{
    constructor(_shop: ShopContent, basket: Collection<BasketItem>, customerNote: string)
    {
        super();

        this.Append(
            new InfoBox("Uwaga!", `Dodawanie i usuwanie produktów odbywa się w krokach AddToBasket. Tutaj można tylko edytować szczegóły istniejących produktów we wszystkich tych krokach.`),
            customerNote && new Box("Notatka klienta: " + customerNote).Class("user-note-in-table-view").FontSize(16),
            new CollectionPrinter(basket, x =>
            {
                switch (x.Type)
                {
                    case BasketItemType.Rent:
                        const rentItem = x as RentBasketItem;
                        return new Table([], [
                            [`Wypożyczenie`,""],
                            ["Produkt", new ProductSelector(_shop.Products.Items, rentItem)],
                            ["Unikalny numer", new TextInput(rentItem.ProductSerialNumber).Bold()],
                            ["Dane dostępowe", new TextInput(rentItem.AccessData)],
                            ["", new RefJsonViewer(rentItem.AccessData)],
                            ["Ilość", new NumberInput(rentItem.Quantity)],
                            ["Koszt", new NumberInput(rentItem.TotalPrice)],
                            ["Depozyt", new NumberInput(rentItem.Deposit)],
                            ["Początek użytkowania", new DateTimeEditInput(rentItem.From)],
                            ["Koniec użytkowania", new DateTimeEditInput(rentItem.To)],
                        ]).Background("#e8f4f7").Padding(16).BorderRadius(8)

                    case BasketItemType.Sale:
                        const saleItem = x as SaleBasketItem;
                        return new Table([], [
                            [`Sprzedaż`,""],
                            ["Produkt", new ProductSelector(_shop.Products.Items, saleItem)],
                            ["Unikalny numer", new TextInput(saleItem.ProductSerialNumber).Bold()],
                            ["Dane dostępowe", new TextInput(saleItem.AccessData)],
                            ["", new RefJsonViewer(saleItem.AccessData)],
                            ["Ilość", new NumberInput(saleItem.Quantity)],
                            ["Koszt", new NumberInput(saleItem.TotalPrice)],
                        ]).Background("#e8f4f7").Padding(16).BorderRadius(8)
                          
                    default:
                        return `No edit form for ${x.Type}`;
                }
            }).Class("panels-container")
            /*

TO JEST LEPSZA OPCJA NA MOBILE ALE NA DESKTOPIE KIEPSKO SIĘ WYŚWIETLA

            new TableViewer(basket).FontSize(14)
                .AddColumn("Typ", x => BasketItemTypeLabels[x.Type])
                .AddColumn("Produkt", x => new ProductSelector(_shop.Products.Items, x))
                .AddColumn("Ilość", x => new NumberInput(x.Quantity))
                .AddColumn("Koszt", x => new NumberInput(x.TotalPrice))
                .AddColumn("Identyfikator", x => new TextInput(x.ProductSerialNumber))
                .AddColumn("Dostępne dane", x => new TextInput(x.AccessData))
                .AddColumn("Depozyt łącznie (w PLN)", x => new NumberInput((x as RentBasketItem).Deposit), x => x.Type === BasketItemType.Rent)
                .AddColumn("Początek użytkowania", x => new DateInput((x as RentBasketItem).From), x => x.Type === BasketItemType.Rent)
                .AddColumn("Koniec użytkowania", x => new DateInput((x as RentBasketItem).To), x => x.Type === BasketItemType.Rent)
                .Build()
                */
        );
    }
}
